/* ActionTypes */
import {
  FETCH_ALL_CHANNELS,
  SCHEDULE_FETCH_CHANNEL_SCHEDULES,
  FETCH_CHANNEL_SCHEDULES_BY_EVENT_TYPE,
} from './actionTypes';
import { generateRequestActionCreator } from '../utils/generators/actionGenerators';

export function fetchAllChannels() {
  return {
    type: FETCH_ALL_CHANNELS,
  };
}

export const scheduleFetchChannelSchedules = generateRequestActionCreator(({
  channelIdOrIds,
  fromDatetime,
  schedulesForChannel,
  sourceProvider,
}) => ({
  type: SCHEDULE_FETCH_CHANNEL_SCHEDULES,
  payload: {
    channelIdOrIds,
    schedulesForChannel,
    fromDatetime,
    sourceProvider,
  },
}));

export const fetchChannelSchedulesByEventType = generateRequestActionCreator(({
  channelId,
  eventType,
  pageSize,
}) => ({
  type: FETCH_CHANNEL_SCHEDULES_BY_EVENT_TYPE,
  payload: {
    channelId,
    eventType,
    pageSize,
  },
}));
